import 'css-chunksrc/client/scenes/projectExpenseEdition/form/elementAttachmentsUpload/styles.scss';export default {
  "attachmentsUploader": "_attachmentsUploader_f2jhx_1",
  "dropzone": "_dropzone_f2jhx_12",
  "dropPreview": "_dropPreview_f2jhx_20",
  "dropPreviewMessage": "_dropPreviewMessage_f2jhx_32",
  "attachmentsUploaderContent": "_attachmentsUploaderContent_f2jhx_37",
  "text": "_text_f2jhx_46",
  "attachmentsButton": "_attachmentsButton_f2jhx_51"
};